export const isDarkColor = (color) => {
  if (!color) return false;
  let cleanColor = color.trim();
  if (cleanColor.includes('gradient')) {
    const hexMatch = cleanColor.match(/#[a-fA-F0-9]{3,6}/);
    if (hexMatch) {
      cleanColor = hexMatch[0];
    } else {
      const rgbMatch = cleanColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
      if (rgbMatch) {
        const r = parseInt(rgbMatch[1], 10);
        const g = parseInt(rgbMatch[2], 10);
        const b = parseInt(rgbMatch[3], 10);
        const yiq = (r * 299 + g * 587 + b * 114) / 1000;
        return yiq < 128;
      }
      return false;
    }
  }
  const cleanHex = cleanColor.replace('#', '');
  if (cleanHex.length === 3) {
    const r = parseInt(cleanHex[0] + cleanHex[0], 16);
    const g = parseInt(cleanHex[1] + cleanHex[1], 16);
    const b = parseInt(cleanHex[2] + cleanHex[2], 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq < 128;
  } else if (cleanHex.length === 6) {
    const r = parseInt(cleanHex.slice(0, 2), 16);
    const g = parseInt(cleanHex.slice(2, 4), 16);
    const b = parseInt(cleanHex.slice(4, 6), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq < 128;
  }
  return false;
};

export const resolveSolidColor = (colorStr, fallback = '#a0c4ff') => {
  if (!colorStr) return fallback;
  const str = String(colorStr).trim();
  if (!str.includes('gradient')) {
    if (str.startsWith('#')) {
      if (str.length === 4) {
        return `#${str[1]}${str[1]}${str[2]}${str[2]}${str[3]}${str[3]}`;
      }
      return str;
    }
    const rgbaMatch = str.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
    if (rgbaMatch) {
      const r = parseInt(rgbaMatch[1], 10).toString(16).padStart(2, '0');
      const g = parseInt(rgbaMatch[2], 10).toString(16).padStart(2, '0');
      const b = parseInt(rgbaMatch[3], 10).toString(16).padStart(2, '0');
      return `#${r}${g}${b}`;
    }
    return str;
  }

  const hexMatch = str.match(/#[a-fA-F0-9]{6}/);
  if (hexMatch) return hexMatch[0];

  const shortHexMatch = str.match(/#[a-fA-F0-9]{3}/);
  if (shortHexMatch) {
    return `#${shortHexMatch[0][1]}${shortHexMatch[0][1]}${shortHexMatch[0][2]}${shortHexMatch[0][2]}${shortHexMatch[0][3]}${shortHexMatch[0][3]}`;
  }

  const rgbaMatch = str.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i);
  if (rgbaMatch) {
    const r = parseInt(rgbaMatch[1], 10).toString(16).padStart(2, '0');
    const g = parseInt(rgbaMatch[2], 10).toString(16).padStart(2, '0');
    const b = parseInt(rgbaMatch[3], 10).toString(16).padStart(2, '0');
    return `#${r}${g}${b}`;
  }

  return fallback;
};
